<template>
	<div class="multi-container">
		<v-layout wrap justify-end
			align-center class="header-booking-data">
			<amounts-component :subsidiary-id="subsidiary" />
			<v-flex xs2>
				<select-button
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiary"
					@input="loadData"
				/>
			</v-flex>
		</v-layout>
		<div v-if="isLoading" class="is-loading">
			<v-progress-circular
				indeterminate
			></v-progress-circular>
			<img
				:src="controlinnLogo"
			/>
		</div>
		<div v-else>
			<v-layout row mb-3>
				<v-flex xs3 d-flex justify-start>
					<select-date
						placeholder="Fecha de inicio"
						icon="event"
						label
						v-model="freeRoomsParams.dateInit"
						@input="loadData"
						:append-icon="arrowIconStart"
					/>
					<select-date
						placeholder="Fecha de fin"
						v-model="freeRoomsParams.dateEnd"
						@input="loadData"
						:append-icon="arrosIconEnd"
					/>
				</v-flex>
			</v-layout>
			<section class="multi-selection-room mb-5">
				<date-header
					:init-day="freeRoomsPerDay.footer.dateInit"
					:end-day="freeRoomsPerDay.footer.dateEnd"
				/>
				<select-room-number
					v-for="(reserve, indexReserve) in roomsSelectedByDayAndReservation"
					:key="indexReserve"
					:class="[
						'reservation',
						indexReserve === lastChild ? null : 'mb-3',
					]"
					:reservation-index="indexReserve"
					:types-rooms="typesRooms"
					:subsidiary="subsidiary"
					:rooms-by-day="reserve"
					:rates="freeRoomsPerDay.footer.ratesPerDates"
					:all-reservation="roomsSelectedByDayAndReservation"
					@update-rooms-selected-data="updateRoomsSelectedData"
					@update-reservation="updateRooms"
				/>
				<free-rooms-day
					:model="freeRoomsPerDay.footer"
					:total="totalAmountInRerservations"
				/>
			</section>
			<v-divider class="mb-5"></v-divider>
			<section>
				<generic-customer-component
					:subsidiary-id="subsidiary"
					@customer-info="customerInfo"
					@invalid-customer-info="invalidCustomerInfo"
				/>
			</section>
			<v-divider class="mb-5"></v-divider>
			<section class="mb-5">
				<v-flex xs12 md2 text-xs-left mb-3>
					<select-button
						class="txt-xs-left"
						label-text="Seleccionar vendedor"
						item-text="name"
						item-value="id"
						:items="sellers"
						v-model="sellerId"
					/>
				</v-flex>
				<channel-component
					@channel-info="channelInfoFn"
					@invalid-channel-info="invalidChannelInfo"
				/>
			</section>
			<v-flex xs12 text-xs-left>
				<label for="">Observaciones del huésped</label>
				<v-text-field
				class="input-border-inset input-textarea input-note mt-1"
				no-resize
				multi-line
				placeholder="Escriba aquí"
				:rows="7"
				textarea
				v-model="specialRequest"
				>
				</v-text-field>
			</v-flex>
			<v-flex></v-flex>
			<section class="action-buttons">
				<v-layout row justify-center mt-4>
					<v-flex xs2 mr-3>
						<v-btn
							class="mr-0 cancel"
						>
							Cancelar
						</v-btn>
					</v-flex>
					<v-flex xs2>
						<v-btn
							class="mr-0 success"
							@click="saveReservations"
							:disabled="invalid"
						>
							Reservar
						</v-btn>
					</v-flex>
				</v-layout>
			</section>
		</div>
	</div>
</template>

<script>
import { differenceInDays, addDays } from 'date-fns';
import amountsComponent from '@/components/shared/AmountsComponent';
import selectDate from '@/clerkinn/shared/select-date';
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import freeRoomsDay from '@/clerkinn/shared/FreeRoomsDay';
import selectRoomNumber from '@/clerkinn/shared/SelectRoomNumber';
import dateHeader from '@/clerkinn/shared/DateHeader';
import mixins from '@/shared/mixins';
import lib from '@/shared/lib';
import helper from '@/shared/helper';
import genericCustomerComponent from '@/clerkinn/shared/GenericCustomerComponent';
import channelComponent from '@/clerkinn/shared/ChannelComponent';

const { compose, setNewProperty, map, reduce } = lib;
const { formatDate } = helper.methods;

function arrowIconStart() {
	const arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrosIconEnd() {
	const arrowEnd = this.menuEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function created() {
	const { initDate, endDate, roomTypeId, numReserve } = this.$route.query;
	this.freeRoomsParams = { dateInit: initDate, dateEnd: endDate, roomTypeId, numReserve };
	this.loadHotels();
}

async function loadHotels() {
	this.isLoading = true;
	const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = subsidiaries.data;
	this.subsidiary = Number(this.$route.query.hotelId) || 463;
	this.loadData();
}

async function loadData() {
	const freeUrl = `${process.env.PMS_URL}/roomtype/${this.subsidiary}/per-dates`;
	const requests = [
		this.$http.get(freeUrl, { params: this.freeRoomsParams }),
		this.$http.get(`${process.env.PMS_URL}/roomtype/${this.subsidiary}`),
		this.$http.get(`${process.env.PMS_URL}/sellers`),
	];
	const [
		{ data: freeRoomsPerDay },
		{ data: roomtypes },
		{ data: sellers },
	] = await Promise.all(requests);
	this.freeRoomsPerDay = freeRoomsPerDay.data;
	this.roomsSelectedByDayAndReservation = freeRoomsPerDay.data.body;
	this.typesRooms = roomtypes.data;
	this.sellers = sellers.data;
	this.isLoading = false;
}

function updateRoomsSelectedData(reservations) {
	this.roomsSelectedByDayAndReservation = [...reservations];
}

function buildBody(rooms, customer, channel, channelInfomation, subsidiary, params, sellerId,
 specialRequest) {
	let fullBody = compose(
		setNewProperty('address', customer.addres),
		setNewProperty('channelId', channel.typeChannelId),
		setNewProperty('channelSelected', channel.channelSelected),
		setNewProperty('cityId', customer.cityId),
		setNewProperty('civilStatus', customer.civilStatus),
		setNewProperty('countryId', customer.countryId),
		setNewProperty('dateBirth', customer.dateBirth),
		setNewProperty('documentType', customer.entity.documentType),
		setNewProperty('email', customer.email),
		setNewProperty('cardVip', customer.cardVip),
		setNewProperty('flagLoyalty', false),
		setNewProperty('gender', customer.gender),
		setNewProperty('lastname', customer.lastname),
		setNewProperty('name', customer.name),
		setNewProperty('numDocument', customer.entity.numDocument),
		setNewProperty('phone', customer.phone),
		setNewProperty('flagTaxes', true),
		setNewProperty('flagGeneric', customer.flagGeneric),
		setNewProperty('website', ''),
		setNewProperty('specialRequest', specialRequest),
		setNewProperty('hotelName', subsidiary),
		setNewProperty('sellerId', sellerId),
	)({});
	fullBody = compose(
		setNewProperty(
			'channelInformation',
			this.getChannelInformation(channelInfomation),
		),
		setNewProperty(
			'bookings',
			this.getBookings(rooms, subsidiary, params),
		),
	)(fullBody);
	return fullBody;
}

function getChannelInformation(channelInfomation) {
	const { fields } = channelInfomation;
	return reduce(this.makeChannelInfo(), fields, {});
}

function makeChannelInfo() {
	return function inner(obj, item) {
		const newObj = { ...obj };
		const prop = item.value;
		newObj[prop] = item[prop];
		return newObj;
	};
}

function getBookings(book, subsidiary, params) {
	const numberNights = differenceInDays(
		params.dateEnd,
		params.dateInit,
	);
	const entityId = params.roomTypeId;
	return map(
		this.makingBooking(
			subsidiary,
			numberNights,
			entityId,
			params,
		),
		book,
	);
}

function makingBooking(subsidiary, numberNights, entityId, params) {
	const self = this;
	return function inner(arr) {
		const total = reduce(self.calculateTotal(), arr, 0);
		const newItem = compose(
			setNewProperty('checkIn', params.dateInit),
			setNewProperty('checkOut', params.dateEnd),
			setNewProperty('currency', 'USD'),
			setNewProperty('adults', 2),
			setNewProperty('childs', 0),
			setNewProperty('rooms', self.getRooms(arr)),
			setNewProperty('entityId', entityId),
			setNewProperty('numberNights', numberNights),
			setNewProperty('numReservation', null),
			setNewProperty('total', total),
			setNewProperty('idSubsidiary', subsidiary),
		)({});
		return newItem;
	};
}

function makeRoomsObject(room) {
	let newRooms = { ...room };
	newRooms = compose(
		setNewProperty('entityId', room.roomTypeId),
		setNewProperty('idRoom', room.idRoom),
		setNewProperty('rate', room.rate),
		setNewProperty('dateInit', room.dateReservation),
		setNewProperty('dateEnd', formatDate(addDays(room.dateReservation, 1), 'YYYY-MM-DD')),
	)({});
	return newRooms;
}

function getRooms(collection) {
	return map(this.makeRoomsObject, collection);
}

function calculateTotal() {
	return function inner(total, room) {
		const rate = Number(room.rate) || 0;
		return total + rate;
	};
}

async function saveReservations() {
	const url = `${process.env.PMS_URL}/bookings-rooms`;
	const body = this.buildBody(
		this.roomsSelectedByDayAndReservation,
		this.customer,
		this.channel,
		this.channelInfo,
		this.subsidiary,
		this.freeRoomsParams,
		this.sellerId,
		this.specialRequest,
	);
	try {
		await this.$http.post(url, body);
		this.showNotification('Las reservas se crearon de forma exitosa', 'success');
		this.$router.push({ name: 'booking-list' });
	} catch (error) {
		this.showNotification(
			'ups!, no fue posible crear las reservas. Intenta mas tarde :)',
			'error',
		);
	}
}

function customerInfo(customer) {
	this.customer = { ...customer };
}

function channelInfoFn(channel, channelInfo) {
	this.channel = { ...channel };
	this.channelInfo = { ...channelInfo };
}

function invalidCustomerInfo(value) {
	this.invalidCustomer = value;
}

function invalidChannelInfo(value) {
	this.invalidChannel = value;
}

function invalid() {
	const customer = this.invalidCustomer;
	const channel = this.invalidChannel;
	const rooms = this.allRoomsSelected(this.roomsSelectedByDayAndReservation);
	return customer || channel || rooms;
}

function allRoomsSelected(rooms) {
	const everyRoomSelected = [];
	rooms.forEach((reservation) => {
		const res = reservation.every(room => room.idRoom);
		everyRoomSelected.push(res);
	});
	return everyRoomSelected.includes(false);
}

function lastChild() {
	const len = this.roomsSelectedByDayAndReservation.length;
	return len - 1;
}

function totalAmountInRerservations() {
	return reduce(this.bigTotal(), this.roomsSelectedByDayAndReservation, 0);
}

function bigTotal() {
	const self = this;
	return function inner(acc, reservation) {
		return acc + reduce(self.calculateTotal(), reservation, 0);
	};
}

function updateRooms(model, indexReservation) {
	this.roomsSelectedByDayAndReservation[indexReservation] = [...model];
}

function data() {
	return {
		specialRequest: '',
		channel: {},
		channelInfo: {},
		controlinnLogo: '/static/img/logo-control-inn.png',
		customer: {},
		endDate: '',
		freeRoomsPerDay: {
			body: [],
			footer: {
				ratesPerDates: [],
			},
		},
		freeRoomsParams: {
			initDate: '2018-09-10',
			endDate: '2018-09-20',
			numReserve: 3,
			roomTypeId: 194,
		},
		roomsSelectedByDayAndReservation: [],
		invalidChannel: true,
		invalidCustomer: true,
		isLoading: false,
		sellers: [],
		sellerId: 0,
		startDate: '',
		subsidiaries: [],
		subsidiary: 0,
		typesRooms: [],
	};
}

export default {
	name: 'select-rooms',
	components: {
		amountsComponent,
		channelComponent,
		dateHeader,
		freeRoomsDay,
		genericCustomerComponent,
		inputText,
		selectDate,
		selectButton,
		selectRoomNumber,
	},
	computed: {
		arrosIconEnd,
		arrowIconStart,
		invalid,
		lastChild,
		totalAmountInRerservations,
	},
	created,
	data,
	methods: {
		allRoomsSelected,
		bigTotal,
		buildBody,
		calculateTotal,
		customerInfo,
		channelInfoFn,
		getBookings,
		getChannelInformation,
		getRooms,
		invalidChannelInfo,
		invalidCustomerInfo,
		loadData,
		loadHotels,
		makingBooking,
		makeChannelInfo,
		makeRoomsObject,
		saveReservations,
		updateRooms,
		updateRoomsSelectedData,
	},
	mixins,
};
</script>

<style lang="scss" scoped>
.multi-container {
	width: 100%;
}

.header-booking-data {
	height: 31px;
	position: absolute;
	right: 20px;
	text-align: right;
	top: 52px;
	width: calc(100% - 230px);
}

.multi-selection-room {
	height: auto;
	overflow: auto;
}

button.btn {
	background-color: white !important;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
	color: map-get($colors, default-button-color);
	height: 40px;
	margin-right: 14px;

	&.success {
		background-color: map-get($colors, button-create) !important;
		color: white;
	}

	&.cancel {
		background-color: map-get($colors, bg-subtitle) !important;
		color: white;
	}
}

.is-loading {
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 100vh;
	justify-content: center;
	width: 100%
}

.reservation {
	background-color: white;
}
</style>





// WEBPACK FOOTER //
// SelectRooms.vue?e4398734